import styled from 'styled-components'
import { ZingTheme } from '../../../assets/theme/types'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const PopUpHeader = styled.div`
  background-color: ${({ theme }) => (theme as ZingTheme).colors.primary};
  height: 53px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  flex-shrink: 0;
`

export const PopUpTitle = styled.h4`
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
  font-size: 20px;
  margin: 0;

  @media (max-width: 575px) {
    font-size: 16px;
  }
`

export const PopUpContent = styled.div`
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 24px;

  @media (max-width: 575px) {
    height: auto;
  }
  padding: 32px 32px 0px 32px;
`

export const PopUpParagraph = styled.span`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
  width: 100%;
  text-align: center;
  display: block;
  overflow: visible;
  line-height: 1.6;
`
